import type { Infer } from 'superstruct';
import { enums } from 'superstruct';

export const MEDIA_KINDS = ['IMAGE', 'VIDEO'] as const;

export const MediaKindDto = enums(MEDIA_KINDS);
export type MediaKind = Infer<typeof MediaKindDto>;

export const MEDIA_DESTINATIONS = ['FACEBOOK', 'GOOGLE', 'GMB'] as const;

export const MediaDestinationDto = enums(MEDIA_DESTINATIONS);
export type MediaDestination = Infer<typeof MediaDestinationDto>;
